<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import {computed, onMounted} from '@vue/composition-api';
    import {DateTime} from "luxon";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config.js"

    export default {
        name: 'EventReportGuest',
        setup(props, {root}) {
            const {Event, EventGuest} = root.$FeathersVuex.api;

            const isTemplate = computed(() => root.$route.params.isTemplate);
            const eventId = computed(() => root.$route.params.eventId);
            const dbColMapping = eConfig.guest.dbColMapping;
            
            const exportGuest = async () => {
                const event = await Event.get(eventId.value);
                const {data: eventGuestArr} = await EventGuest.find({
                    query: {
                        eventId: eventId.value,
                    },
                });
                
                const titleCols = Object.values(dbColMapping);
                let extraCols = [];
                try {
                    extraCols = [...new Set(eventGuestArr.map((row)=>Object.keys(JSON.parse(row.metadata) || {})).flat(1))];
                } catch (e) {
                    extraCols = [];
                }
                
                let excelData = [];
                if (!isTemplate.value) {
                    for (let eventGuest of eventGuestArr) {
                        let guestRow = [];
                        for (let titleCol of titleCols) {
                            if (titleCol === 'username') {
                                guestRow.push(eventGuest.guests.username || '');
                            } else {
                                guestRow.push(eventGuest[titleCol] || '');
                            }
                        }
                        if (extraCols.length > 0 && eventGuest.metadata) {
                            const extra = JSON.parse(eventGuest.metadata) || {};
                            for (let extraCol of extraCols) {
                                guestRow.push(extra[extraCol] || '');
                            }
                        }
                        excelData.push(guestRow);
                    }
                }
                
                excelData.unshift([...Object.keys(dbColMapping), ...extraCols]);
                const ws = XLSX.utils.aoa_to_sheet(excelData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, event.name.substring(0,30));
                XLSX.writeFile(wb, 'guest_'+eventId.value+'_'+DateTime.local().toFormat('yyyyMMdd_HHmmss')+'.xlsx');
                
                root.$router.go(-1);
            }
            
            onMounted(() => {
                exportGuest();
            });

            return {
            }
        },
    }
</script>
